/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_ASSET_INCOMES_SUCCESS,
  GET_ASSET_INCOMES_FAILURE,
  GET_ASSET_MONTHWISE_INCOMES_SUCCESS,
  GET_ASSET_MONTHWISE_INCOMES_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  incomes: [],
  monthwiseIncomes: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ASSET_INCOMES_SUCCESS:
      return {
        getAssetIncomesSuccess: true,
        incomes: action.payload.incomes,
      };
    case GET_ASSET_INCOMES_FAILURE:
      return {
        getAssetIncomesSuccess: false,
        incomes: state.incomes,
      };
    case GET_ASSET_MONTHWISE_INCOMES_SUCCESS:
      return {
        getAssetMonthwiseIncomesSuccess: true,
        monthwiseIncomes: action.payload.monthwiseIncomes,
      };
    case GET_ASSET_MONTHWISE_INCOMES_FAILURE:
      return {
        getAssetMonthwiseIncomesSuccess: false,
        monthwiseIncomes: state.monthwiseIncomes,
      };

    default:
      return state;
  }
}
